<script>
export default {
  name: "MenuView",
  data() {
    return {
      queryData: {
        pageNo: 1,
        pageSize: 10,
        name: '',
        parentId: ''
      },
      total: 0,
      dataList: [],
      disabled: true,
      selectChange: [],
      selectChangeId: [],
      title: '',
      DialogVisible: false,
      formData: {
        id: '',
        icon: '',
        name: '',
        url: '',
        type: '1',
        orderNumber: '',
        parentId: '',
        parentName: '',
        remarks: ''
      },
      formRules: {},
      options: [],
      value: '',
      menuTree: [],
      num: 1
    }
  },
  created() {
    this.list()
    this.allList()
  },
  methods: {
    list() {
      const _this = this
      this.$axios.post('menu/list', this.queryData).then(function (res) {
        _this.dataList = res.data.data.records
        _this.total = res.data.data.total
      }).catch(function (err) {
        _this.$Message.error(err)
      })
    },
    handleSizeChange(pageSize) {
      this.queryData.pageSize = pageSize
      this.list()
    },
    handleCurrentChange(pageNo) {
      this.queryData.pageNo = pageNo
      this.list()
    },
    // eslint-disable-next-line no-unused-vars
    stateFormatType(row, column) {
      if (row.type === '1') {
        return '目录'
      } else {
        return '菜单'
      }
    },
    allList() {
      const _this = this
      this.$axios.post('menu/all/list').then(function (res) {
        _this.options = res.data.data
        _this.menuTree = res.data.data
      }).catch(function (err) {
        _this.$Message.error(err)
      })
    },
    selectData(val) {
      this.queryData.parentId = val
    },
    handleSearch() {
      this.list()
    },
    clear() {
      this.list()
    },
    handleAdd: function () {
      this.title = '添加菜单'
      this.DialogVisible = true
    },
    handleEdit(id) {
      this.title = '编辑菜单'
      this.DialogVisible = true
      const _this = this
      const data = {
        id: id
      }
      this.$axios.post('menu/detail', data).then(function (res) {
        _this.formData = res.data.data
        _this.num = res.data.data.orderNumber
      }).catch(function (err) {
        _this.$Message.error(err)
      })
    },
    handleDelete(id) {
      const _this = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.delete(id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    delete(id) {
      const _this = this
      const data = {
        id: id
      }
      this.$axios.post('menu/delete', data).then(function (res) {
        if (res.data.code === 200) {
          _this.$message({
            type: 'success',
            message: res.data.msg
          })
          _this.list()
          _this.allList()
        } else {
          _this.$message({
            type: 'error',
            message: res.data.msg
          })
        }
      }).catch(function (err) {
        _this.$Message.error(err)
      })
    },
    changeSelect(val) {
      this.selectChange = val
      this.lengths = this.selectChange.length
      this.disabled = this.lengths === 0
    },
    getIds() {
      for (let i = 0; i < this.selectChange.length; i++) {
        this.selectChangeId.push(this.selectChange[i].id)
      }
    },
    // 批量删除按钮
    handleDeletes() {
      const _this = this
      this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.deleteAll()
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
        _this.selectChangeId = []
      })
    },
    deleteAll() {
      this.getIds()
      const _this = this
      this.loading = true
      this.$axios.post('menu/deletes', this.selectChangeId).then(function (res) {
        _this.$message({
          type: 'success',
          message: res.data.msg
        })
        _this.list()
        _this.allList()
      }).catch(function (err) {
        _this.$Message.error(err)
      })
    },
    selectTopMenuData(val) {
      this.formData.parentId = val.id
      this.formData.parentName = val.name
    },
    handleChange(value) {
      this.formData.orderNumber = value
    },
    handleSave() {
      const _this = this
      this.$axios.post('menu/save', this.formData).then(function (res) {
        _this.$refs.formRef.resetFields()
        _this.formData.id = ''
        _this.num = '1'
        _this.$message({
          type: 'success',
          message: res.data.msg
        })
        _this.DialogVisible = false
        _this.list()
        _this.allList()
      }).catch(function (err) {
        _this.$Message.error(err)
      })
    },
    handleCancel() {
      Object.keys(this.formData).forEach(key => this.formData[key] = '');
      this.num = '1'
      this.$refs.formRef.resetFields()
      this.DialogVisible = false
    },
    closeDialog() {
      Object.keys(this.formData).forEach(key => this.formData[key] = '');
      this.num = '1'
      this.$refs.formRef.resetFields()
      this.DialogVisible = false
    },
    setValueNull() {
      this.queryData.parentId = ''
      this.list()
    }
  }
}
</script>

<template>
  <div>
    <!--    <el-breadcrumb separator="/">-->
    <!--      <el-breadcrumb-item>系统管理</el-breadcrumb-item>-->
    <!--      <el-breadcrumb-item>菜单管理</el-breadcrumb-item>-->
    <!--    </el-breadcrumb>-->
    <el-row style="margin-top:20px ">
      <el-col :span="4">
        <el-input placeholder="名称" v-model="queryData.name" clearable @clear="clear"></el-input>
      </el-col>
      <el-col :span="4" style="margin-left: 20px">
        <el-select v-model="value" value-key="id" placeholder="请选择上级菜单" @change="selectData"
                   @clear="setValueNull"
                   clearable>
          <el-option v-for="item in options" :key="item.id" :label="item.name"
                     :value="item.id"
                     :disabled="item.disabled">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3" style="margin-left: 20px">
        <el-button type="primary" @click="handleSearch">搜索</el-button>
      </el-col>
    </el-row>
    <el-row style="text-align: left;margin-top: 20px">
      <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleAdd">新增</el-button>
      <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDeletes" :disabled="disabled">删除
      </el-button>
    </el-row>
    <el-table :data="dataList" style="width: 100%;margin-top: 20px" border @selection-change="changeSelect">
      <el-table-column type="selection" width="50" align="center">
      </el-table-column>
      <el-table-column label="图标" prop="icon" width="50" align="center">
        <template slot-scope="scope">
          <i :class="scope.row.icon"></i>
        </template>
      </el-table-column>
      <el-table-column label="名称" prop="name" align="center"></el-table-column>
      <el-table-column label="地址" prop="url" align="center"></el-table-column>
      <el-table-column label="类型" prop="type" align="center" :formatter="stateFormatType"></el-table-column>
      <!--      <el-table-column label="排序" prop="orderNumber" width="100" align="center"></el-table-column>-->
      <el-table-column label="上级菜单" prop="parentName" align="center"></el-table-column>
      <el-table-column label="版本" prop="version" align="center"></el-table-column>
      <!--      <el-table-column label="备注" prop="remarks" width="200" align="center"></el-table-column>-->
      <el-table-column label="创建时间" prop="createTime" width="180" align="center"></el-table-column>
      <el-table-column label="更新时间" prop="updateTime" width="180" align="center"></el-table-column>
      <el-table-column label="操作" align="center" width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="handleEdit(scope.row.id)">编辑</el-button>
          <el-button size="mini" type="text" @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block" style="margin-top: 20px">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryData.pageNo"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="queryData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>
    <el-dialog :title="title" :visible.sync="DialogVisible" width="50%" center @close='closeDialog'>
      <el-form :model="formData" :rules="formRules" ref="formRef" label-width="50px">
        <el-form-item label="上级" prop="parentName">
          <el-select v-model="formData.parentName" value-key="id" placeholder="请选择上级菜单"
                     @change="selectTopMenuData">
            <el-option v-for="item in menuTree" :key="item.id" :label="item.name"
                       :value="item"
                       :disabled="item.disabled">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="图标" prop="icon">
          <icon-picker v-model="formData.icon"></icon-picker>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="formData.type" style="margin-bottom: 0">
            <el-radio :label="'1'">目录</el-radio>
            <el-radio :label="'2'">菜单</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="formData.type ==='2'" label="地址" prop="url">
          <el-input v-model="formData.url"></el-input>
        </el-form-item>
        <!--        <el-form-item label="类型" prop="type">-->
        <!--          <el-input v-model="formData.type"></el-input>-->
        <!--        </el-form-item>-->
        <el-form-item label="排序" prop="orderNumber">
          <!--          <el-input v-model="formData.orderNumber"></el-input>-->
          <el-input-number v-model="num" @change="handleChange" :min="1" :max="100" label="描述文字"></el-input-number>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input v-model="formData.remarks"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="handleCancel">取 消</el-button>
    <el-button type="primary" @click="handleSave">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<style scoped>

</style>